<template>
    <div class="profile-page col-xl-12 col-lg-12 col-md-12 order-2">
        <div id="MyTransaction" class="row">
            <div class="col-lg-12">
                <div class="col-12">
                    <h1 class="title-tab-content">همه سفارش ها</h1>
                </div>
                <div class="content-section default">
                    <div class="row">
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="tab-bar mt20 inner-tab">
                                <div id="tab-20" class="tab-content current cm-list">
                                    <div class="all-content col-md-12 col-sm-12 col-xs-12 ">
                                        <ul class="table-row hidden-md hidden-sm hidden-xs">
                                            <!--<li class="a first-th col-td table-cell">ردیف</li>-->
                                            <li class="b col-3 col-title table-cell text-center">عنوان</li>
                                            <li class="c col-3 col-td table-cell">تاریخ/ساعت</li>
                                            <li class="d col-3 col-td table-cell">برداشت/واریز</li>
                                            <li class="e col-3 col-td table-cell">موجودی</li>
                                        </ul>
                                    </div>
                                    <hr>
                                    <div v-if="transactions.length > 0" class="row table-row-content">
                                        <div :class="['col-md-12', 'col-sm-12', 'col-xs-12',(transaction.Withdraw != 0) ? 'row-com2' : 'row-com1']" v-for="(transaction,index) in transactions">
                                            <!--<div class="div-center col-lg-1 d-none d-md-block">{{index + 1}}</div>-->
                                            <div class="div-center complate-m col-lg-3  col-sm-6  col-xs-12">
                                                <div class="dic-m">
                                                    <span class="typeInvoice">{{transaction.FinancialTransactionTypes}}</span>
                                                    <span class="InvoiceCode">
                                                        <a href="#">   {{  transaction.OrderId != '' ? 'به شماره سفارش ' + transaction.OrderId : ''}}</a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="div-center date-m col-lg-3 col-md-6 col-sm-6 col-xs-6 d-none d-sm-block">{{transaction.RegDateTime}}</div>
                                            <div :class="['div-center', 'col-lg-2 ','col-sm-6',' col-xs-6', 'throw-digit',(transaction.Withdraw == 0)?'throw-m-green':'throw-m-red' ]">{{(transaction.Withdraw == 0 ? transaction.Deposit : transaction.Withdraw) | formatNumber }}</div>
                                            <div class="div-center balance-m col-lg-2 col-sm-6  col-xs-6">
                                                <span class="balanc-title-m"></span> <span style="font-size:14px;font-weight:450">{{transaction.Balance | formatNumber}}</span>
                                            </div>
                                            <span :class="['d-block' , 'd-md-none' ,(transaction.Withdraw != 0) ? 'p-m-mines' :'p-m-plus' ]">{{transaction.Withdraw != 0 ? ' - ' : ' + '}}</span>
                                        </div>
                                    </div>
                                    <div v-else class="col-md-12 col-sm-12 col-xs-12">

                                        <div class="orderTraceEmpty">
                                            <span>تراکنشی برای شما ثبت نشده است.</span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="customerTransactionsPaging" class="pager default text-center"></div>
                </div>
            </div>
            <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:50%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return { transactions: [], isShowSppiner: false }
        },
        computed: {
            cravings: function () {
                return true;
            }
        },
        methods: {
            readCustomerTransactions(pageNum) {
                this.isShowSppiner = true;
                httpPromise(this, '/v1/Identity/customerFininces/Read', 'get', { Page: pageNum },
                    response => {
                        this.transactions = response.data.Value.Transactions;
                        this.createPaging(response.data.Value.TotalCount, response.data.Value.Page);
                        this.isShowSppiner = false;
                        $(function () { $('html, body').animate({ scrollTop: 0 }, 800, 'easeInExpo'); })

                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            },
            createPaging(totalDataCount, pageNumber) {
                var component = this;
                $(function () {
                    try {
                        $('#customerTransactionsPaging').pagination('destroy');
                    } catch  { }
                    var dataSource = [];
                    for (var i = 1; i <= totalDataCount; i++)
                        dataSource.push(i);
                    if (dataSource != null && dataSource.length > 0) {
                        var container = $('#customerTransactionsPaging').pagination({
                            dataSource: dataSource,
                            pageSize: 10,
                            pageNumber: pageNumber,
                            classPrefix: 'pager',
                            ulClassName: 'pager-items',
                            activeClassName: 'is-active',
                        });
                        container.addHook('afterPaging', function () {
                            var pageNum = container.pagination('getSelectedPageNum');
                            component.readCustomerTransactions(pageNum);
                        });
                    }

                });
            },
        },
        beforeMount: function () {
            createPageTitle('تراکنش های من');
            this.readCustomerTransactions(0);
        },
    }
</script>>

<style scoped>
    .orderTraceEmpty {
        border: 1px solid #ddd;
        text-align: center;
        border-radius: 5px;
        padding: 20px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        background-color: #fcfcfc;
    }

    .content-section {
        min-height: 450px;
    }

    .typeInvoice {
        display: block;
    }

    #MyTransaction .throw-m-green {
        color: #9fd172;
    }

    #MyTransaction .throw-m-red {
        color: #dd6060;
    }

    .table-row-content {
        margin-bottom: 30px;
    }

    .row-com1, .row-com2 {
        display: flex;
    }

    .row-com2 {
        padding: 20px 0 20px 0;
    }

    .row-com1 {
        padding: 20px 0 20px 0;
    }

        .row-com1 .div-center, .row-com2 .div-center {
            text-align: center;
        }

    .table-row-content > div:nth-child(even) {
        background-color: beige;
    }


    #MyTransaction .table-row {
        background-color: #ddd;
        padding: 10px 5px 10px 5px;
        border-radius: 5px;
    }

    #MyTransaction .a {
        margin-right: 5px;
    }

    /*#MyTransaction .b, #MyTransaction .c, #MyTransaction .d, #MyTransaction .e {
        margin-right: 128px;
    }

    #MyTransaction .b {
        margin-right: 90px;
    }*/

    .all-content ul li {
        display: inline-block;
    }

    .table-row {
        margin-top: 25px;
    }

    .row-com1 .complate-m .dic-m, .row-com2 .complate-m .dic-m, .row-com1 .date-m, .row-com2 .date-m {
        font-size: 13px;
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        #MyTransaction .throw-m-red {
            position: absolute;
            bottom: 10px;
            right: 20px;
            font-size: 15px;
            font-weight: bold;
            color: #dd6060;
        }

        #MyTransaction .throw-m-green {
            position: absolute;
            bottom: 10px;
            right: 15px;
            font-size: 15px;
            font-weight: bold;
            color: #9fd172;
        }

        #MyTransaction .balance-m, .date-m {
            text-align: left;
        }

        #MyTransaction .balance-m {
            position: absolute;
            bottom: 10px;
            left: 12px;
            font-size: 15px;
            font-weight: bold;
        }

        .row-com1[data-v-09ac1e50] {
            display: unset;
        }

        #MyTransaction .p-m-plus {
            font-size: 25px;
            color: #fff;
            position: absolute;
            right: 4px;
            bottom: -8px;
            z-index: 9;
        }

        #MyTransaction .p-m-mines {
            font-size: 37px;
            color: #fff;
            position: absolute;
            right: 7px;
            bottom: -16px;
            z-index: 9;
        }

        .table-row-content {
            background-color: #fff !important;
            margin: 0;
        }

        .typeInvoice {
            display: unset;
        }

        #MyTransaction .balance-m {
            position: absolute;
            bottom: 10px;
            left: 12px;
            font-size: 15px;
            font-weight: bold;
        }

        #MyTransaction .balance-m, .date-m {
            text-align: left;
        }

        #MyTransaction .row-com2, #MyTransaction .row-com1 {
            height: 90px !important;
            padding-left: 0;
            padding-right: 0;
            position: relative;
        }

        #MyTransaction .table-row-content .row-com2, #MyTransaction .table-row-content .row-com1 {
            border: 2px solid #ddd;
        }

        #MyTransaction .row-com2::after {
            position: absolute;
            content: '';
            width: 0;
            height: 0;
            bottom: 0;
            right: 0;
            border-left: 20px solid transparent;
            border-right: 20px solid red;
            border-top: 20px solid transparent;
            border-bottom: 20px solid red;
        }

        #MyTransaction .row-com1::after {
            position: absolute;
            content: '';
            width: 0;
            height: 0;
            bottom: 0;
            right: 0;
            border-left: 20px solid transparent;
            border-right: 20px solid green;
            border-top: 20px solid transparent;
            border-bottom: 20px solid green;
        }

        #MyTransaction .table-row-content .row-com1, #MyTransaction .table-row-content .row-com2 {
            border: 2px solid #ddd;
        }

        #MyTransaction .row-com1, #MyTransaction .row-com2 {
            height: 90px;
            padding-left: 0;
            padding-right: 0;
            position: relative;
        }

        .dic-m, .row-com1 .div-center, .row-com2 .div-center {
            text-align: right;
        }
    }

    @media only screen and (min-width:650px) and (max-width: 850px) {

        .date-m {
            position: absolute;
            left: -9px;
            top: 5px;
            font-size: 13px;
        }

        #MyTransaction .table-row-content .row-com1, #MyTransaction .table-row-content .row-com2 {
            border: 2px solid #ddd;
        }

        #MyTransaction .row-com2, #MyTransaction .row-com1 {
            height: 90px;
            padding-left: 0;
            padding-right: 0;
            position: relative;
        }

        #MyTransaction .complate-m {
            padding-right: 5px;
            font-size: 12px;
        }

        #MyTransaction .date-m {
            margin-bottom: 25px;
        }

        #MyTransaction .throw-m-red {
            position: absolute;
            bottom: 10px;
            right: 26px;
            font-size: 15px;
            font-weight: bold;
            color: #dd6060;
        }

        #MyTransaction .throw-m-green {
            position: absolute;
            bottom: 10px;
            right: 26px;
            font-size: 15px;
            font-weight: bold;
            color: #9fd172;
        }

        #MyTransaction .balance-m {
            position: absolute;
            bottom: 10px;
            left: 12px;
            font-size: 15px;
            font-weight: bold;
        }

        #MyTransaction .balance-m, #MyTransaction .date-m {
            text-align: left;
        }

        .row-com1 .complate-m, .row-com2 .complate-m {
            text-align: right;
        }

        #MyTransaction .throw-m-green, #MyTransaction throw-m-red {
            text-align: right;
        }

        #MyTransaction .p-m-mines {
            font-size: 30px;
            color: #fff;
            position: absolute;
            right: 7px;
            bottom: -16px;
            z-index: 9;
        }

        #MyTransaction .p-m-plus {
            font-size: 30px;
            color: #fff;
            position: absolute;
            right: 4px;
            bottom: -10px;
            z-index: 9;
        }

        #MyTransaction .row-com2::after {
            position: absolute;
            content: '';
            width: 0;
            height: 0;
            bottom: 0;
            right: 0;
            border-left: 20px solid transparent;
            border-right: 20px solid red;
            border-top: 20px solid transparent;
            border-bottom: 20px solid red;
        }

        #MyTransaction .row-com1::after {
            position: absolute;
            content: '';
            width: 0;
            height: 0;
            bottom: 0;
            right: 0;
            border-left: 20px solid transparent;
            border-right: 20px solid green;
            border-top: 20px solid transparent;
            border-bottom: 20px solid green;
        }
    }
</style>